import React from 'react'
import PropTypes from 'prop-types'

import S from '../Loading.styled'
import Button from './Button'

const ButtonGroup = ({ className = '', num = 2 }) => {
  const total = num > 4 ? 4 : num

  return (
    <S.ButtonGroup className={`button-group${className}`}>
      {[...Array(total).keys()].map((item) => (
        <Button key={item} />
      ))}
    </S.ButtonGroup>
  )
}

ButtonGroup.propTypes = {
  className: PropTypes.string,
  num: PropTypes.number,
}

export default ButtonGroup
